import * as s from '~/lib/normalize/schema';

// Organizations
export const OrganizationSchema = s.obj({
  id: s.field(),
  name: s.field(),
  orgType: s.alias('type'),
  active: s.field(),
  street1: s.field(),
  street2: s.field(),
  city: s.field(),
  state: s.field(),
  zipcode: s.field(),
  receiptType: s.alias('receipt_type'),
  administrativeFee: s.alias('administrative_fee'),
  administrativeFeeMode: s.alias('administrative_fee_mode'),
  createdAt: s.alias('created_at', s.date()),
  updatedAt: s.alias('updated_at', s.date()),
});

export const OrganizationListSchema = s.list(OrganizationSchema);

// Locations
export const LocationSchema = s.obj({
  id: s.field(),
  name: s.field(),
  street1: s.field(),
  street2: s.field(),
  city: s.field(),
  state: s.field(),
  zipcode: s.field(),
  locationMapping: s.alias('location_mapping', s.list(s.obj({
    siteId: s.alias('site_id', s.field()),
  }))),
  administrativeFee: s.alias('administrative_fee'),
  administrativeFeeMode: s.alias('administrative_fee_mode'),
});

export const LocationListSchema = s.list(LocationSchema);

// Users
export const UserSchema = s.obj({
  id: s.field(),
  username: s.field(),
  email: s.field(),
  firstName: s.alias("first_name"),
  lastName: s.alias("last_name"),
  role: s.field(),
  organizationId: s.alias("organization_id"),
  organization: OrganizationSchema,
  locationId: s.alias("location_id"),
  departmentId: s.alias("department_id"),
  shift: s.field(),
  forcePasswordChange: s.alias("force_password_change"),
  permissions: s.field(),
  createdAt: s.alias("created_at", s.date()),
  updatedAt: s.alias("updated_at", s.date()),
});

export const UserListSchema = s.list(UserSchema);

export const UserChangeRequest = s.obj({
  username: s.field(),
  email: s.field(),
  password: s.field(),
  firstName: s.alias('first_name'),
  lastName: s.alias('last_name'),
  role: s.field(),
  organizationId: s.alias('organization_id'),
  locationId: s.alias('location_id'),
  departmentId: s.alias('department_id'),
  shift: s.field(),
  forcePasswordChange: s.alias('force_password_change'),
});


// User authentication stuff
export const UserAuthSchema = s.obj({
  user: UserSchema,
  token: s.field(),
});

// Transactions
export const TransactionSchema = s.obj({
  id: s.field(),
  transactionType: s.alias('type'),
  status: s.field(),
  date: s.date(),
  workDate: s.alias('work_date', s.date()),
  note: s.field(),
  processDate: s.alias('process_date', s.date()),
  receiptUrl: s.alias('receipt_url'),
  amount: s.alias('amount.value', s.currency()),
  locationId: s.alias('location_id'),
  location: LocationSchema,
  userId: s.alias('user_id'),
  user: UserSchema,
  toOrganizationId: s.alias('to_organization_id'),
  toOrganization: s.alias('to_organization', OrganizationSchema),
});

export const TransactionListSchema = s.list(TransactionSchema);

// Balance
export const BalanceSchema = s.obj({
  balance: s.currency(),
});

// Information Settings Request
export const InformationSettingsSchema = s.obj({
  appUrl: s.alias('app_url'),
  paymentTypes: s.alias('payment_types'),
  features: s.field(),
});

export const DepartmentSchema = s.obj({
  id: s.field(),
  name: s.field(),
  organizationId: s.alias('organization_id'),
  locationId: s.alias('location_id'),
  createdAt: s.alias('created_at', s.date()),
  updatedAt: s.alias('updated_at', s.date()),
});

export const DepartmentListSchema = s.list(DepartmentSchema);

export const ResetPasswordEmailRequest = s.obj({
  email: s.field(),
})

export const ResetPasswordRequest = s.obj({
  newPassword: s.alias('new_password'),
  repeatPassword: s.alias('repeat_password'),
})

export const ValidateTokenSchema = s.obj({
  token: s.field(),
})
